import { render, staticRenderFns } from "./ThemePage.vue?vue&type=template&id=dade571e&scoped=true"
import script from "./ThemePage.vue?vue&type=script&lang=ts"
export * from "./ThemePage.vue?vue&type=script&lang=ts"
import style0 from "./ThemePage.vue?vue&type=style&index=0&id=dade571e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dade571e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dade571e')) {
      api.createRecord('dade571e', component.options)
    } else {
      api.reload('dade571e', component.options)
    }
    module.hot.accept("./ThemePage.vue?vue&type=template&id=dade571e&scoped=true", function () {
      api.rerender('dade571e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ThemePage.vue"
export default component.exports